import { supabase } from '../lib/supabase.ts';

// 인앱 브라우저에서 외부 브라우저로 이동 (제스처 컨텍스트 안에서 직접 호출해야 함)
export const openExternalBrowser = () => {
  const ua = navigator.userAgent;
  if (/kakaotalk/gi.test(ua)) {
    location.href = 'kakaotalk://web/openExternal?url=' + encodeURIComponent(location.href);
  } else {
    window.open(location.href, '_blank');
  }
};

// 인앱 브라우저 감지 (외부에서 사용 가능)
export const isInAppBrowser = (): boolean => {
  const ua = navigator.userAgent || navigator.vendor;
  return (
    /kakaotalk/gi.test(ua) ||
    /Instagram|FBAN|FBAV|FB_IAB|Barcelona/i.test(ua) ||
    /Line/i.test(ua)
  );
};

// 인앱브라우저면 signInWithGoogle 직접 호출 (handleInAppBrowser가 location.href 변경으로 OS 다이얼로그 띄움)
// 인앱브라우저 아니면 onLoginRequired(모달 열기) 실행
export const handleLoginRequired = (onLoginRequired: () => void, signInFn?: () => Promise<any>) => {
  if (!isInAppBrowser()) {
    onLoginRequired();
    return;
  }
  if (signInFn) signInFn().catch(() => {});
};

// 인앱 브라우저 감지 및 처리
const handleInAppBrowser = () => {
  const ua = navigator.userAgent || navigator.vendor;
  const currentUrl = window.location.href;
  const isIOS = /iPhone|iPad|iPod/i.test(ua);
  const isAndroid = /Android/i.test(ua);

  // 디버깅: User-Agent 화면에 표시 (필요시 사용)
  if (window.location.search.includes('debug=ua')) {
    alert('User-Agent:\n\n' + ua);
    return false;
  }

  // 카카오톡: 외부 브라우저로 강제 이동
  if (/kakaotalk/gi.test(ua)) {
    location.href = 'kakaotalk://web/openExternal?url=' + encodeURIComponent(currentUrl);
    return true;
  }

  // Gmail 인앱브라우저 감지 (GSA = Google Search App)
  const isGmail = /GSA\//.test(ua) || /Gmail/.test(ua);
  if (isGmail) {
    if (isIOS) {
      const lang = navigator.language.toLowerCase();
      const message = lang.startsWith('ja')
        ? 'SafariまたはChromeで開いてください\n\n右上の [···] ボタンをタップして\n「Safariで開く」を選択してください'
        : lang.startsWith('ko')
        ? 'Safari 또는 Chrome에서 열어주세요\n\n우측 하단 [...] 버튼을 눌러\n브라우저에서 열기를 선택해주세요'
        : 'Please open in Safari or Chrome\n\nTap [...] at the bottom right\nand select "Open in Browser"';
      alert(message);
    } else if (isAndroid) {
      const intentUrl =
        'intent://' +
        location.host +
        location.pathname +
        location.search +
        location.hash +
        '#Intent;scheme=https;package=com.android.chrome;end';
      window.location.href = intentUrl;
    }
    return true;
  }

  // Meta 앱들 (Instagram, Facebook, Threads) 감지
  const isMetaApp = /Instagram|FBAN|FBAV|FB_IAB|Barcelona/i.test(ua);

  if (isMetaApp) {
    if (isIOS) {
      const lang = navigator.language.toLowerCase();
      const message = lang.startsWith('ja')
        ? '外部ブラウザで開いてください\n\n右上の [···] ボタンをタップして\n「外部ブラウザで開く」を選択してください'
        : lang.startsWith('ko')
        ? '외부 브라우저에서 열어주세요\n\n우측 상단 [···] 버튼을 눌러\n외부 브라우저에서 열기를 선택해주세요'
        : 'Please open in external browser\n\nTap [···] at the top right\nand select “Open in external browser”';
      alert(message);
    } else if (isAndroid) {
      const intentUrl =
        'intent://' +
        location.host +
        location.pathname +
        location.search +
        location.hash +
        '#Intent;scheme=https;package=com.android.chrome;end';
      window.location.href = intentUrl;
    }
    return true;
  }

  if (/Line/i.test(ua)) {
    return true;
  }

  return false;
};

export const googleAuth = {
  signInWithGoogle: async () => {
    try {
      // 인앱 브라우저면 외부로 이동 후 return (에러 throw 안 함)
      if (handleInAppBrowser()) {
        return;
      }

      const { data, error } = await supabase.auth.signInWithOAuth({
        provider: 'google',
        options: {
          redirectTo: `${window.location.origin}${window.location.pathname}`,
        },
      });

      if (error) throw error;
      return data;
    } catch (error) {
      console.error('Error during Google sign-in:', error);
      throw error;
    }
  },

  signOut: async () => {
    try {
      const { error } = await supabase.auth.signOut();
      if (error) throw error;
    } catch (error) {
      console.error('Error during sign-out:', error);
      throw error;
    }
  },
};

// 페이지 로드 시 인앱 브라우저 체크 (공유 링크로 접근 시)
export const checkInAppBrowserOnLoad = () => {
  handleInAppBrowser();
};
